import { Injectable } from '@angular/core';
import { TypesObject } from '../models/dto/typesobject';

export class SurveyTypes {
    titles = [{ id: 1, title: '3 MOIS' }, { id: 2, title: '1 AN' }, { id: 3, title: '3 ANS' }, { id: 4, title: '10 ANS' }];

    constructor() { }

    getTitle(id: number): string {
        if (this.titles.filter(x => x.id == id)[0]) {
            return this.titles.filter(x => x.id == id)[0].title;
        }
        return '';
    }

    getTitleId(title: string): number {
        if (this.titles.filter(x => x.title === title)[0]) {
            return this.titles.filter(x => x.title === title)[0].id;
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/models/surveytypes.ts